// 購入履歴：注文の日時・商品・金額・状態。処理中は確認し直せる。注文番号（末尾）はお問い合わせ用。
import { api, type Order } from '../api';
import { register } from '../router';
import { resumePendingOrder, setPendingOrder } from '../session';
import { state, subscribe } from '../state';
import { esc, fmt } from '../ui/dom';
import { artIcon, icon } from '../ui/icons';
import { toast } from '../ui/overlay';
import { loadInto } from '../ui/status';
import '../ui/fit';

const STATUS: Record<string, { label: string; cls: string }> = {
  pending: { label: '処理中', cls: 'wait' },
  paid: { label: '反映済み', cls: 'ok' },
  expired: { label: '期限切れ', cls: '' },
  refunded: { label: '返金済み', cls: '' },
  disputed: { label: '確認中', cls: 'red' },
};
const dt = (at: number) => new Date(at).toLocaleString('ja-JP', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });

register('purchases', {
  title: '購入履歴',
  nav: 'shop',
  mount(el) {
    el.innerHTML = `<div class="page fill"><section class="panel-paper deco page-paper purchases">
      <header class="screen-head"><h1 class="screen-title">${artIcon('ledger')}購入履歴</h1><div class="end"><button class="btn small" data-back>${icon('left')}ショップ</button></div></header>
      <div class="pending-slot"></div><div class="hist fit-scroll"></div>
      <p class="muted small">注文番号（末尾）はお問い合わせの際にお伝えください。</p></section></div>`;
    el.querySelector('[data-back]')!.addEventListener('click', () => (location.hash = '#/shop'));
    const pending = () => {
      el.querySelector('.pending-slot')!.innerHTML = state.pendingOrder
        ? `<div class="pending-bar" role="status"><div class="spinner small"></div><div class="grow"><b>購入の反映を待っています</b><small>決済の確認が届きしだい反映されます。</small></div><button class="btn small" data-recheck>確認する</button></div>`
        : '';
    };
    pending();
    const off = subscribe((ch) => ch.has('pendingOrder') && pending());
    const box = el.querySelector<HTMLElement>('.hist')!;
    void loadInto(box, '購入履歴', api.orders, (r) => {
      box.innerHTML = r.orders.length
        ? `<table class="orders"><thead><tr><th>日時</th><th>商品</th><th class="num">金額</th><th>状態</th></tr></thead><tbody>${r.orders
            .map((o: Order) => {
              const st = STATUS[o.status] ?? { label: esc(o.status), cls: '' };
              return `<tr><td class="num">${dt(o.createdAt)}</td><td><b>${esc(o.name)}</b><small class="muted">No. ${esc(o.id.slice(-12))}</small></td><td class="num">¥${fmt(o.amount)}</td>
                <td><em class="tag ${st.cls}">${st.label}</em>${o.status === 'pending' ? ` <button class="btn small" data-check="${esc(o.id)}">確認する</button>` : ''}</td></tr>`;
            })
            .join('')}</tbody></table>`
        : `<div class="state-box empty">${icon('history')}<p>購入履歴はありません。</p></div>`;
    });
    const click = (e: Event) => {
      const t = e.target as HTMLElement;
      const b = t.closest<HTMLElement>('[data-check]');
      if (b) {
        setPendingOrder(b.dataset.check!);
        resumePendingOrder(true);
        toast('照会しています…');
      } else if (t.closest('[data-recheck]')) resumePendingOrder(true);
    };
    el.addEventListener('click', click);
    return () => {
      off();
      el.removeEventListener('click', click);
    };
  },
});
